import { AxiosInstance } from 'axios';

import { Store } from 'webPosApp/models/Index';
import { ErrorCodes } from 'shared/helpers/constants';

export function UseErrorInterceptor(instance: AxiosInstance) {
    instance.interceptors.response.use((_) => _, errorsInterceptor);
}

function errorsInterceptor(error: any) {
    const { response } = error;

    // Client errors
    if (response && response.status >= 400) {
        if (response.status === 401) {
            console.log(error);
            window.location = response.headers.location;
            return new Promise((resolve, reject) => {});
        }

        const errorDescription = Store.configuration.parseError(response);

        // check if envrionment error
        if (
            response.status === 403 &&
            errorDescription.code === ErrorCodes.invalidEnvironment
        ) {
            //in this case we just reload page, since response contains Cookie with valid environment
            //and next request with always go to valid environment (it's configured by Tech Support Team)
            window.location.reload();

            return Promise.reject(response);
        }

        console.error(error, errorDescription);
        // alert(`Error was occured. HttpCode: ${errorDescription.httpCode}, errorCode: ${errorDescription.code}, message: ${errorDescription.message}. There will be good modal with error description in future`)
    }

    return Promise.reject(response);
}
